export const APP_SERVER_TIME = 'app.SERVER_TIME';


// WEBPACK FOOTER //
// ./src/types/app.js